var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegafonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95299 2.89212V11.0278C5.95299 11.6198 5.47312 12.0997 4.88116 12.0997C4.4282 12.0997 4.02413 11.8149 3.87178 11.3883L2.56451 7.64315M10.2164 7.22725C11.2255 7.22725 12.0435 6.4092 12.0435 5.40009C12.0435 4.39098 11.2255 3.57293 10.2164 3.57293M2.56451 7.64315C1.69224 7.27237 1.08057 6.40766 1.08057 5.40008C1.08057 4.0546 2.17129 2.96388 3.51677 2.96388H4.63261C7.13012 2.96388 9.27652 2.21225 10.2164 1.13672L10.2164 9.66346C9.27652 8.58793 7.13012 7.8363 4.63261 7.8363L3.51676 7.83629C3.17886 7.83629 2.85703 7.7675 2.56451 7.64315Z",
    stroke: "#14BD44",
    strokeWidth: 1.46173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegafonIcon);
export default __webpack_public_path__ + "static/media/megafon-icon.abeebe1b3c0ababb2ca1b6cf4e2a332b.svg";
export { ForwardRef as ReactComponent };